import SyosSeat from '../SyosSeat';

export interface PartialClientRect {
  top: number;
  bottom: number;
  left: number;
  right: number;
  width: number;
  height: number;
}

export interface SeatClientRectContainerData {
  scale: number;
  clientRect: PartialClientRect;
}

export interface Container {
  getSeatClientRectContainerData: () => SeatClientRectContainerData;
}

class SeatClientRectProvider {
  container?: Container;

  constructor(container: Container) {
    this.container = container;
  }

  get(seat: SyosSeat): PartialClientRect | undefined {
    if (!this.container) {
      return;
    }

    const { scale, clientRect: containerRect } = this.container.getSeatClientRectContainerData();

    const top = (seat.y * scale) + containerRect.top;
    const left = (seat.x * scale) + containerRect.left;

    const size = SyosSeat.GRID_UNIT_SIZE * scale;

    return {
      top,
      bottom: top + size,
      left,
      right: left + size,
      width: size,
      height: size,
    };
  }

  destroy() {
    this.container = undefined;
  }
}

export default SeatClientRectProvider;
